module.exports = __webpack_public_path__ + "img/logo2.c50f6c23.png";